import { gql } from '@apollo/client';

export const ALL_PLANS = gql`
  query AllPlans {
    plans: getUserPlans {
      id
      name
    }
  }
`;
